import _ from "@lodash";
import { AppBar, Checkbox, DialogActions, DialogContent, FormControl, FormControlLabel, IconButton, MenuItem, Step, StepButton, Stepper, TextField, Toolbar, Typography } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import MobileDetect from "mobile-detect";
import React, { useCallback, useRef } from "react";
import { MdClose } from "react-icons/md";
import { connect } from "react-redux";
import clsx from "clsx";
import Constante from 'Constante.json';
import { bindActionCreators } from "redux";
import * as Actions from "../../Store/Actions/ComunicadorActions";
import { formatMs } from "@material-ui/core/styles/transitions";
import Conteudos from "../../Components/Conteudos";
import Destinatarios from "../../Components/Destinatarios";

const md = new MobileDetect(window.navigator.userAgent);

const newComunicadorState = {
    "step": 0,
    "idmensagem": null,
    "idperfil": null,
    "tipo": 1,
    "confirmacao": 0,
    "interacao": 0,
    "autostart": 0,
    "assunto": "",
    "conteudos": [],
    "locais": []
};

const STEPS = [
    { "id": "detalhes", "label": "Detalhes" },
    { "id": "conteudos", "label": "Conteúdos" },
    { "id": "destinatarios", "label": "Destinatários" }
];

class CentralNotificacoesDialog extends XAPPComponent {

    state = { ...newComunicadorState };

    componentDidUpdate(prevProps, prevState) {
        const { Comunicador } = this.props;
        if (Comunicador.error) {
            this.props.showMessage({
                message: Comunicador.error,
                variant: "error"
            });
            Comunicador.error = null;
        }
        if (Comunicador.warning) {
            this.props.showMessage({
                message: Comunicador.warning,
                variant: "warning"
            });
            Comunicador.warning = null;
        }
        if (Comunicador.info) {
            Comunicador.info = null;
            this.props.openDialog();
        }

        if (!_.isNull(this.props.open) && !_.isEqual(prevProps.open, this.props.open)) {
            if (!_.isNull(Comunicador.perfis) && Comunicador.perfis.length > 0) {
                this.setState(_.set({ ...this.props.open }, "idperfil", Comunicador.perfis[0].idperfil));
            }
        }

        if (_.isNull(this.props.open) && !_.isEqual(prevProps.open, this.props.open)) {
            this.setState(Object.assign({}, newComunicadorState));
        }
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.type === "checkbox" ? event.target.checked : event.target.value));
    };

    handleChangePerfil = (event) => {
        const { Comunicador } = this.props;
        let APerfil = _.find(Comunicador.perfis, { idperfil: event.target.value });
        this.setState({ ...this.state, "idperfil": APerfil.idperfil });
    }

    handleStep = (_AIndex) => {
        this.setState(_.set({ ...this.state }, "step", _AIndex));
    }

    canGoNextStep = () => {
        const form = this.state;
        switch (form.step) {
            case 0: return (
                !_.isNull(form.tipo) &&
                !_.isNull(form.assunto) && form.assunto !== ""
            );
            case 1: {
                let AReturn = false;
                if (form.conteudos.length > 0) {
                    AReturn = true;
                    form.conteudos.map(item => {
                        if (item.conteudo.length < 1) {
                            AReturn = false;
                        }
                    });
                }
                return AReturn;
            }
            case 2: {
                return form.locais.length > 0;
            }
            default: return false;
        }
    }

    render() {
        const { save, xappRouteParams, Comunicador, openDialog, open = null, theme } = this.props;
        const form = this.state;

        return (
            <XAPPDialog
                id="CentralNotificacoes"
                open={!_.isNull(open)}
                onClose={() => openDialog()}
                fullWidth
                maxWidth="md"
            >
                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">
                            {_.isNull(form.idmensagem) ? "Nova mensagem" : "Editar mensagem"}
                        </Typography>
                        <div style={{ flex: 1 }} />
                        <IconButton
                            key="close"
                            aria-label="Close"
                            className="p-6"
                            onClick={() => openDialog()}
                        >
                            <MdClose className="text-20 text-white" />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent className="p-20 overflow-hidden">
                    <Stepper nonLinear activeStep={form.step} className="p-12 mb-12">
                        {STEPS.map((item, index) => (
                            <Step key={item.id}>
                                <StepButton
                                    onClick={() => {
                                        if (index < form.step) {
                                            this.handleStep(index);
                                        }
                                    }}
                                    completed={form.step === index}
                                >
                                    {item.label}
                                </StepButton>
                            </Step>
                        ))}
                    </Stepper>
                    <div className={form.step === 0 ? "block" : "hidden"}>
                        <TextField
                            className="flex mb-12 w-full"
                            label="Assunto"
                            id="assunto"
                            name="assunto"
                            value={form.assunto}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <div className={clsx("flex md:flex-no-wrap flex-wrap")}>
                            <div className="w-full">
                                <TextField
                                    className="flex mb-12 w-full md:mr-8 max-fu"
                                    label="Tipo"
                                    id="tipo"
                                    name="tipo"
                                    value={form.tipo}
                                    onChange={this.handleChange}
                                    variant="outlined"
                                    fullWidth
                                    select
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                >
                                    {Constante.mensagem_tipos.map(item => (
                                        <MenuItem id={item.id} value={item.value}>{item.label}</MenuItem>
                                    ))}
                                </TextField>
                                <TextField
                                    className="flex mb-12 w-full md:mr-8"
                                    label="Perfil"
                                    id="idperfil"
                                    name="idperfil"
                                    value={form.idperfil}
                                    onChange={this.handleChangePerfil}
                                    variant="outlined"
                                    fullWidth
                                    select
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                >
                                    {!_.isNull(Comunicador.perfis) && Comunicador.perfis.map(item => (
                                        <MenuItem id={item.idperfil} value={item.idperfil}>{item.nome}</MenuItem>
                                    ))}
                                </TextField>
                            </div>
                            <FormControl id={"confirmacao"} className={"mb-12 items-start flex-col w-1/3"}>
                                <FormControlLabel
                                    className={clsx("m-0 flex-row items-center")}
                                    control={
                                        <Checkbox
                                            className="px-8 py-4"
                                            name={"confirmacao"}
                                            type='checkbox'
                                            checked={form.confirmacao === 1}
                                            onChange={ev => this.handleChange({ "target": { "name": "confirmacao", "value": form.confirmacao === 1 ? 0 : 1 } })}
                                        />
                                    }
                                    label={<Typography className='text-start mr-16 text-16'>{"Confirmação"}</Typography>}
                                />
                                <FormControlLabel
                                    className={clsx("m-0 flex-row items-center")}
                                    control={
                                        <Checkbox
                                            className="px-8 py-4"
                                            name={"interacao"}
                                            type='checkbox'
                                            checked={form.interacao === 1}
                                            onChange={ev => this.handleChange({ "target": { "name": "interacao", "value": form.interacao === 1 ? 0 : 1 } })}
                                        />
                                    }
                                    label={<Typography className='text-start mr-16 text-16'>{"Interações"}</Typography>}
                                />
                                <FormControlLabel
                                    className={clsx("m-0 flex-row items-center")}
                                    control={
                                        <Checkbox
                                            className="px-8 py-4"
                                            name={"autostart"}
                                            type='checkbox'
                                            checked={form.autostart === 1}
                                            onChange={ev => this.handleChange({ "target": { "name": "autostart", "value": form.autostart === 1 ? 0 : 1 } })}
                                        />
                                    }
                                    label={<Typography className='text-start mr-16 text-16'>{"Abertura automatica"}</Typography>}
                                />
                            </FormControl>
                        </div>
                    </div>
                    <div className={form.step === 1 ? "block" : "hidden"}>
                        <Conteudos
                            data={form}
                            handleChange={this.handleChange}
                            theme={theme}
                        />
                    </div>
                    <div className={form.step === 2 ? "block" : "hidden"}>
                        <Destinatarios
                            data={form}
                            handleChange={this.handleChange}
                            theme={theme}
                            destinatarios={Comunicador?.destinatarios}
                        />
                    </div>
                </DialogContent>
                <AppBar position="static" elevation={3} color="textSecondary">
                    <Toolbar className="flex w-full justify-end min-h-0 px-8">
                        <DialogActions>
                            {form.step === 2 &&
                                <XAPPButton
                                    type="Button"
                                    className="bg-green hover:bg-green text-white mr-8"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => save(form, "INSERIR")}
                                    disabled={!this.canGoNextStep()}
                                    iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                    icon={"save"}
                                    label={md.mobile() === null && md.tablet() === null ? "Salvar" : ""}
                                />
                            }
                            {form.step < 2 &&
                                <XAPPButton
                                    type="Button"
                                    className="bg-green hover:bg-green text-white mr-8"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => this.handleStep(form.step + 1)}
                                    disabled={!this.canGoNextStep()}
                                    iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                    icon={"save"}
                                    label={md.mobile() === null && md.tablet() === null ? "Próximo" : ""}
                                />
                            }
                        </DialogActions>
                    </Toolbar>
                </AppBar>
            </XAPPDialog>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        showMessage: AppActions.showMessage,
        openDialog: Actions.openDialog
    }, dispatch);
}

function mapStateToProps({ Comunicador, fuse }) {
    return {
        Comunicador: Comunicador,
        open: Comunicador.dialog,
        theme: fuse.settings.mainTheme
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CentralNotificacoesDialog);
